import { render, staticRenderFns } from "./BDXEditForm.vue?vue&type=template&id=49f1708b&scoped=true"
import script from "./BDXEditForm.vue?vue&type=script&lang=js"
export * from "./BDXEditForm.vue?vue&type=script&lang=js"
import style0 from "./BDXEditForm.vue?vue&type=style&index=0&id=49f1708b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f1708b",
  null
  
)

export default component.exports